import { Torus } from "@react-three/drei";

const GroundCircle = ({ position, radius }) => {
  return (
    <Torus
      args={[radius, 0.01, 4, 45]}
      position={position}
      rotation-x={Math.PI * 0.5}
    >
      <meshBasicMaterial color={"#D3AF5F"} />
    </Torus>
  );
};

export default GroundCircle;
